<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Repacking" active>

                                <b-row v-if="hasFailedDataRepacking">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedRepacking.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="repackingsFailed" :fields="fieldsRepacking" :busy="isDataLoading"
                                                         :sort-by.sync="sortByRepacking" :sort-desc.sync="sortDescRepacking" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(repackDate)="row">
													{{ row.item.repackDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(startDate)="row">
													{{ row.item.startDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(finishDate)="row">
													{{ row.item.finishDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedRepacking.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="repackings" :fields="fieldsRepacking" :busy="isDataLoading"
                                                         :sort-by.sync="sortByRepacking" :sort-desc.sync="sortDescRepacking" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(repackDate)="row">
													{{ row.item.repackDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(startDate)="row">
													{{ row.item.startDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(finishDate)="row">
													{{ row.item.finishDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Repacking Detail" active>

                                <b-row v-if="hasFailedDataRepackingDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedRepackingDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="repackingDetailsFailed" :fields="fieldsRepackingDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByRepackingDetail" :sort-desc.sync="sortDescRepackingDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(startDate)="row">
													{{ row.item.startDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(finishDate)="row">
													{{ row.item.finishDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(qtyRepack)="row">
													{{ Number(row.item.qtyRepack).toLocaleString() }}
												</template>
												<template #cell(qtyOutstanding)="row">
													{{ Number(row.item.qtyOutstanding).toLocaleString() }}
												</template>
												<template #cell(qtyFullfiled)="row">
													{{ Number(row.item.qtyFullfiled).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedRepackingDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="repackingDetails" :fields="fieldsRepackingDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByRepackingDetail" :sort-desc.sync="sortDescRepackingDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(startDate)="row">
													{{ row.item.startDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(finishDate)="row">
													{{ row.item.finishDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(qtyRepack)="row">
													{{ Number(row.item.qtyRepack).toLocaleString() }}
												</template>
												<template #cell(qtyOutstanding)="row">
													{{ Number(row.item.qtyOutstanding).toLocaleString() }}
												</template>
												<template #cell(qtyFullfiled)="row">
													{{ Number(row.item.qtyFullfiled).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Repacking Control Card" active>

                                <b-row v-if="hasFailedDataRepackingControlCard">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedRepackingControlCard.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="repackingControlCardsFailed" :fields="fieldsRepackingControlCard" :busy="isDataLoading"
                                                         :sort-by.sync="sortByRepackingControlCard" :sort-desc.sync="sortDescRepackingControlCard" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(scanDate)="row">
													{{ row.item.scanDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>
												<template #cell(qtyOriginal)="row">
													{{ Number(row.item.qtyOriginal).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedRepackingControlCard.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="repackingControlCards" :fields="fieldsRepackingControlCard" :busy="isDataLoading"
                                                         :sort-by.sync="sortByRepackingControlCard" :sort-desc.sync="sortDescRepackingControlCard" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(scanDate)="row">
													{{ row.item.scanDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>
												<template #cell(qtyOriginal)="row">
													{{ Number(row.item.qtyOriginal).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import Repacking from '@/models/Repacking/Repacking';
import RepackingList from '@/models/Repacking/RepackingList';
import RepackingFilter from '@/filters/Repacking/RepackingFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsRepacking: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction", key: 'deliveryInstructionDiNumber', sortable: false},
				{"class" : "th-status", "label" : "Repack Date", key: 'repackDate', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date", key: 'deliveryDate', sortable: false},
				{"class" : "th-status", "label" : "Repack Status", key: 'repackStatusName', sortable: false},
				{"class" : "th-status", "label" : "Repack By", key: 'repackByFirstName', sortable: false},
				{"class" : "th-status", "label" : "Start Date", key: 'startDate', sortable: false},
				{"class" : "th-status", "label" : "Finish Date", key: 'finishDate', sortable: false},
				{"class" : "th-status", "label" : "PO No Customer", key: 'poNoCustomer', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsRepackingDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Repack Status", key: 'repackStatusName', sortable: false},
				{"class" : "th-status", "label" : "Repack By", key: 'repackByFirstName', sortable: false},
				{"class" : "th-status", "label" : "Start Date", key: 'startDate', sortable: false},
				{"class" : "th-status", "label" : "Finish Date", key: 'finishDate', sortable: false},
				{"class" : "th-status", "label" : "Qty Repack", key: 'qtyRepack', sortable: false},
				{"class" : "th-status", "label" : "Qty Outstanding", key: 'qtyOutstanding', sortable: false},
				{"class" : "th-status", "label" : "Qty Fullfiled", key: 'qtyFullfiled', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsRepackingControlCard: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Repacking Detail", key: 'repackingDetailDeliveryInstructionDetail', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Scan By", key: 'scanByFirstName', sortable: false},
				{"class" : "th-status", "label" : "Scan Date", key: 'scanDate', sortable: false},
				{"class" : "th-status", "label" : "Qty", key: 'qty', sortable: false},
				{"class" : "th-status", "label" : "Qty Original", key: 'qtyOriginal', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			repackings : [],
			repackingsFailed: [],
			repackingId : '',
			sortByRepacking: '',
			sortDescRepacking: '',
			hasFailedDataRepacking: false,
			totalFailedRepacking: 0,
			totalSucceedRepacking: 0,
			repackingDetails : [],
			repackingDetailsFailed: [],
			repackingDetailId : '',
			sortByRepackingDetail: '',
			sortDescRepackingDetail: '',
			hasFailedDataRepackingDetail: false,
			totalFailedRepackingDetail: 0,
			totalSucceedRepackingDetail: 0,

			repackingControlCards : [],
			repackingControlCardsFailed: [],
			repackingControlCardId : '',
			sortByRepackingControlCard: '',
			sortDescRepackingControlCard: '',
			hasFailedDataRepackingControlCard: false,
			totalFailedRepackingControlCard: 0,
			totalSucceedRepackingControlCard: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('repacking/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('repacking/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getRepackingForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getRepackingForUpload : async function() {
			let _this = this;
			this.$http.get('repacking/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.repackings = [];
_this.repackingDetails = [];
_this.repackingControlCards = [];


					if (response != null) {
						let result = response.data;
						_this.repackings = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedRepacking = _this.repackings.length;

						_this.repackingsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataRepacking = true;
						_this.totalFailedRepacking = 0;
						if(_this.repackingsFailed == undefined || _this.repackingsFailed.length === 0) _this.hasFailedDataRepacking = false;
						if(_this.hasFailedDataRepacking) _this.totalFailedRepacking = _this.repackingsFailed.length;
						_this.repackingDetails = [];
						_this.repackingDetailsFailed = [];
						_this.hasFailedDataRepackingDetail = true;
						_this.totalSucceedRepackingDetail = 0;
						result.forEach(function(element) {
							_this.repackingDetails.push(...element.repackingDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedRepackingDetail = _this.repackingDetails.length;

							_this.repackingDetailsFailed.push(...element.repackingDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.repackingDetailsFailed == undefined || _this.repackingDetailsFailed.length === 0) _this.hasFailedDataRepackingDetail = false;
							if(_this.hasFailedDataRepackingDetail) _this.totalFailedRepackingDetail = _this.repackingDetailsFailed.length;
						});						_this.repackingControlCards = [];
						_this.repackingControlCardsFailed = [];
						_this.hasFailedDataRepackingControlCard = true;
						_this.totalSucceedRepackingControlCard = 0;
						result.forEach(function(element) {
							_this.repackingControlCards.push(...element.repackingControlCard.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedRepackingControlCard = _this.repackingControlCards.length;

							_this.repackingControlCardsFailed.push(...element.repackingControlCard.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.repackingControlCardsFailed == undefined || _this.repackingControlCardsFailed.length === 0) _this.hasFailedDataRepackingControlCard = false;
							if(_this.hasFailedDataRepackingControlCard) _this.totalFailedRepackingControlCard = _this.repackingControlCardsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'repacking/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'Repacking.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterRepacking = new RepackingFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
